module.exports = __webpack_public_path__ + "84d81dad7cda3693afed6755d0a37c5e.pdf";